import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FormWizardSteps } from 'src/app/models/shared-models';
import { VegWizardDataService } from 'src/app/veg-wizard/services/veg-wizard-data.service';
import { VegWizardStateMachineService } from 'src/app/veg-wizard/services/veg-wizard-state-machine.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateLandholderDetailsGuard implements CanActivate {
  constructor(public vwds: VegWizardDataService,
    public stateMachine: VegWizardStateMachineService,
    public router: Router) {}

  canActivate() {

    const dataState = this.vwds.getWizardDataState();

    const result = this.stateMachine.getLandHolderDetailsRouterProperties(dataState);

    if (!result.isEnabled) {
      console.warn('CanActivateLandholderDetailsGuard - Required data does not exist!');
      this.router.navigate([FormWizardSteps.LandHolderConfirmation]);
      return false;
    }

    return result.isEnabled;
  }

}
